export const SET_AUTH = "setAuthToken";
export const SET_PERMISSIONS = "setPermissions";
export const VERIFY_2FA_CODE = "verify2FACode";
export const PURGE_AUTH = "removeAuth";

export const SET_ERROR = "setError";
export const SET_LOADING = "setLoading";
export const SET_SELECTED_COMMITTEE = 'setSelectedCommittee';
